import { Component } from '@angular/core';

@Component({
    selector: 'blue-pencil-character',
    templateUrl: '../../../../../../src/assets/svgs/characters/bluepencil.svg',
    styleUrls: ['../svg.component.scss']
})
export class BluePencilCharacter {

}